<tui-push *tuiPush="open" [type]="'Warning' | translate" (close)="toggle(false)">
  {{ 'Your account will be blocked' | translate }}:
  <b>{{ blockingAccountDate | customDate }}</b>
  <tui-svg [src]="'tuiIconWarningLarge'"></tui-svg>
</tui-push>
